import script from "./RegisterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterForm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterForm.vue?vue&type=style&index=0&id=3f285f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f285f38"]])

export default __exports__